import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@cuepid/influencer/env';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  enableProdMode();
}

Sentry.init(environment.sentry);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
